type P = {
  alt: string;
  src: string;
};

const ContentLeftImage = ({ alt, src }: P) => (
  <div className="content-left-image">
    <img alt={alt} className="content-left-image__img" src={src} />
  </div>
);

export default ContentLeftImage;
